<div>
    <div class="row w-100 p-1 p-sm-1 p-md-4 m-0 ">
        <div class="col-12" style="padding-left:3%;">
            <span class="textBeforeStart muted-color"> {{ 'START.LABEL1' | translate }} </span>
        </div>
        <div class="col-md-6 mt-3" style="padding-right:2%;padding-left: 2%;">
            <span class="textTitleGeneral black-color"> {{ 'START.LABEL2' | translate }} </span>
            <ul id="lista" class="m-0 h-25 d-inline-block">
                <li class="textNormalBlack black-color">
                    {{ 'START.LABEL3' | translate }} 
                </li>
                <li class="textNormalBlack black-color">
                    {{ 'START.LABEL4' | translate }} 
                </li>
                <li class="textNormalBlack black-color">
                    {{ 'START.LABEL5' | translate }} 
                </li>
            </ul>
            <div class="d-block d-sm-block d-md-none my-4">
                <div class="row vertical">
                    <div class="col-6">
                        <div class="row" style="margin-top:0px;">
                            <div class="col-3 p-0">
                                <div class="bar-item-vertical muted-light-color"></div>
                            </div>
                            <div class="col-9 p-0">
                                <span class="textVerticalTitle black-color"> {{ 'START.LABEL6' | translate }} </span><br>
                                <span class="textVertical muted-color"> {{ 'START.LABEL7' | translate }} </span>
                            </div>
                        </div>
                        <div class="row" style="margin-top:30px;">
                            <div class="col-3 p-0">
                                <div class="bar-item-vertical-second primary-color"></div>
                            </div>
                            <div class="col-9 p-0" style="margin-top: 90px;">
                                <span class="textVerticalTitle black-color"> {{ 'START.LABEL2' | translate }} </span><br>
                                <span class="textVertical muted-color"> {{ 'START.LABEL8' | translate }} </span>
                            </div>
                        </div>
        
                    </div>
                    <div class="col-6">
                        <div class="row">
                            <div class="col-4 arrow-dotted-vertical" style="padding-right:0%">
                                <div id="compra" class="img-sm" style="margin-top: -30px;">
                                </div>
                                <div id="reemplazo" style="margin-top: 180px;"
                                    class="img-sm"></div>
                            </div>
                            <div class="col-8">
                                <span class="textVertical muted-color"> {{ 'START.LABEL9' | translate }} </span><br><br>
                                <div id="voltaje" style="margin: 0 auto;"
                                    class="img-sm textVertical muted-color"></div>
                                <span class="textVertical muted-color"> {{ 'START.LABEL10' | translate }} </span><br><br>
                                <span class="textVertical muted-color"> {{ 'START.LABEL11' | translate }} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6 mt-3" style="padding-left: 2%;padding-right:2%;">
            <span class="textTitleGeneral"> {{ 'START.LABEL12' | translate }} </span><br>
            <ul id="lista" class="m-0 h-25 d-inline-block">
                <li class="textNormalBlack black-color">
                    {{ 'START.LABEL13' | translate }} 
                </li>
                <li class="textNormalBlack black-color">
                    {{ 'START.LABEL14' | translate }} 
                </li>
                <li class="textNormalBlack black-color">
                    {{ 'START.LABEL15' | translate }} 
                </li>
        
            </ul>
            <div class="d-block d-sm-block d-md-none my-4">
                <div class="row vertical">
                    <div class="col-6">
                        <div class="row" style="margin-top:0px;">
                            <div class="col-3 p-0">
                                <div class="bar-item-vertical muted-light-color"></div>
                            </div>
                            <div class="col-9 p-0 ">
                                <span class="textVerticalTitle black-color"> {{ 'START.LABEL6' | translate }} </span><br>
                                <span class="textVertical muted-color"> {{ 'START.LABEL7' | translate }} </span>
                            </div>
                        </div>
                        <div class="row" style="margin-top:30px;">
                            <div class="col-3 p-0">
                                <div class="bar-item-vertical-second primary-color"></div>
                            </div>
                            <div class="col-9 p-0" style="margin-top:70px">
                                <span class="textVerticalTitle black-color"> {{ 'START.LABEL12' | translate }} </span><br>
                                <span class="textVertical muted-color"> {{ 'START.LABEL8' | translate }} </span>
                            </div>
                        </div>
        
                    </div>
                    <div class="col-6">
                        <div class="row">
                            <div class="col-4 arrow-dotted-vertical" style="padding-right:0%">
                                <div id="compra" class="img-sm" style="margin-top: -30px;">
                                </div>
                                <div id="reparacion" style="margin-top: 185px;" class="img-sm"></div>
                            </div>
                            <div class="col-8">
                                <span class="textVertical muted-color"> {{ 'START.LABEL9' | translate }} </span><br><br>
                                <div id="voltaje" style="margin: 0 auto;" class="img-sm textVertical muted-color"></div>
                                <span class="textVertical muted-color"> {{ 'START.LABEL10' | translate }} </span><br><br>
                                <span class="textVertical muted-color"> {{ 'START.LABEL11' | translate }} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row w-100 p-md-4 pb-md-5 m-0">
        <div class="col-md-6 " style="padding-right:2%;padding-left: 2%;">
            <div class="d-none d-sm-none d-md-block">
                <div class="row">
                    <div class="col-6 text-center">
                        <span class="textNormalTitle black-color"> {{ 'START.LABEL6' | translate }} </span><br>
                        <span class="textNormal muted-color"> {{ 'START.LABEL7' | translate }} </span>
                    </div>
        
                    <div class="col-6 text-center">
                        <span class="textNormalTitle black-color"> {{ 'START.LABEL2' | translate }} </span><br>
                        <span class="textNormal muted-color"> {{ 'START.LABEL8' | translate }} </span>
                    </div>
                </div>
        
                <div class="row">
                    <div class="col">
                        <div class="container-bar">
                            <div class="bar-item muted-light-color"></div>
                            <div class="bar-item primary-color" style="margin-left: -20px;"></div>
                        </div>
                    </div>
                </div>
        
                <div class="row">
                    <div class="col">
                        <div id="compra" class="img-bg"></div>
                    </div>
        
                    <div class="col text-center">
                        <div id="reemplazo" style="margin: 0 auto;" class="img-bg">
                        </div>
                    </div>
                </div>
        
                <div class="row">
                    <div class="col">
                        <div class="arrow-dotted"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span class="textNormal muted-color muted-color"> {{ 'START.LABEL9' | translate }} </span>
                    </div>
                    <div class="col-6 d-flex justify-content-end">
                        <span class="textNormal muted-color muted-color"> {{ 'START.LABEL11' | translate }} </span>
                    </div>
                </div>
        
                <div class="row">
                    <div class="col">
                        <div id="voltaje" style="margin: 0 auto;" class="img-bg">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 d-flex justify-content-center pb-3 h-25">
                        <span class="textNormal muted-color"> {{ 'START.LABEL10' | translate }} </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6" style="padding-left: 2%;padding-right:2%;">
            <div class="d-none d-sm-none d-md-block">
                <div class="row">
                    <div class="col-6 text-center">
                        <span class="textNormalTitle black-color"> {{ 'START.LABEL6' | translate }} </span><br>
                        <span class="textNormal muted-color"> {{ 'START.LABEL7' | translate }} </span>
                    </div>
        
                    <div class="col-6 text-center">
                        <span class="textNormalTitle black-color"> {{ 'START.LABEL12' | translate }} </span><br>
                        <span class="textNormal muted-color"> {{ 'START.LABEL8' | translate }} </span>
                    </div>
                </div>
        
                <div class="row">
                    <div class="col">
                        <div class="container-bar">
                            <div class="bar-item muted-light-color"></div>
                            <div class="bar-item primary-color" style="margin-left: -20px;"></div>
                        </div>
                    </div>
                </div>
        
                <div class="row">
                    <div class="col">
                        <div id="compra" class="img-bg"></div>
                    </div>
        
                    <div class="col text-center">
                        <div id="reparacion" style="margin: 0 auto;" class="img-bg"></div>
                    </div>
                </div>
        
                <div class="row">
                    <div class="col">
                        <div class="arrow-dotted"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span class="textNormal muted-color"> {{ 'START.LABEL9' | translate }} </span>
                    </div>
                    <div class="col-6 d-flex justify-content-end">
                        <span class="textNormal muted-color"> {{ 'START.LABEL11' | translate }} </span>
                    </div>
                </div>
        
                <div class="row">
                    <div class="col">
                        <div id="voltaje" style="margin: 0 auto;" class="img-bg"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 d-flex justify-content-center pb-3 h-25">
                        <span class="textNormal muted-color"> {{ 'START.LABEL10' | translate }} </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>